<template>
    <node-view-wrapper class="wrapper">
        <button 
            :class="node.attrs.class" 
            @click="handleClick"
        >
            {{ node.attrs.label }}
        </button>
    </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper } from '@tiptap/vue-2';
export default {
  name: 'ButtonComponent',
  props: {
    node: {
      type: Object,
      required: true,
    },
    updateAttributes: {
      type: Function,
      required: true,
    },
  },
    components: {
        NodeViewWrapper
    },
  methods: {
    handleClick() {
      if (this.node.attrs.href) {
        window.open(this.node.attrs.href, '_blank')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper{
    display: inline;
}
button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  background-color: #E2E2E2;
  color: #333;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #969696;
}
</style> 